import { useState } from "react";
import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faq";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);
  const visible = faqs.slice(0, 4);

  return (
    <section className="border-y border-background-200/80 bg-background-100 py-16 md:py-20">
      <Container>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题"
              description="关于我们的判断方法、内容原则与更新节奏，先在这里说清楚。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
            >
              查看全部问题
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {visible.map((faq) => {
                const isOpen = openId === faq.id;
                return (
                  <div key={faq.id}>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100"
                    >
                      <span className="text-sm font-medium text-foreground-900 md:text-[15px]">
                        {faq.question}
                      </span>
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"} />
                      </span>
                    </button>
                    {isOpen ? (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.answer}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}